import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useModal from 'hooks/useModal';

import { sendEvent } from 'lib/gtag';

import Context from './Context';
import Like from './LikeButton';
import Share from './Share';

import OFFER from 'constants/offer';

const WishlistSuggestionsModal = dynamic(
  () => import('./WishlistSuggestionsModal')
);

/**
 * Offers with status WAITING are only accessible by the user
 * who posted it, shouldn't be able to share. FINISHED offers
 * shouldn't be shared for some reason too.
 */
const isOfferShareableInSocialMedia = (offerStatusName) =>
  offerStatusName !== OFFER.STATUSES.WAITING &&
  offerStatusName !== OFFER.STATUSES.FINISHED;

const Actions = ({
  gaEventCategory,
  keywords,
  offerId,
  offerLikes,
  offerPrice,
  offerPriceType,
  offerStatusName,
  offerTitle,
  offerCoupon,
  offerInstructions,
  userId,
}) => {
  const { showModal } = useModal();

  const onOpenWishlistSuggestions = () => {
    sendEvent({
      action: 'show_wishlist_suggestions',
      category: gaEventCategory,
    });
    showModal(WishlistSuggestionsModal, { keywords });
  };

  return (
    <>
      <Button
        className="ml-auto [&>svg]:text-rd-primary-700 dark:[&>svg]:text-rd-primary-700 dark:[&>svg]:hover:text-primary-400"
        icon={<Icon name="heart" />}
        size="size3"
        type="primary-ghost"
        onClick={onOpenWishlistSuggestions}
      />
      <div className="flex items-center justify-end gap-3">
        {isOfferShareableInSocialMedia(offerStatusName) && (
          <Share
            gaEventCategory={gaEventCategory}
            offerPrice={offerPrice}
            offerPriceType={offerPriceType}
            offerTitle={offerTitle}
          />
        )}
      </div>
      <Like
        gaEventCategory={gaEventCategory}
        likesCount={offerLikes}
        offerId={offerId}
        size="size3"
        type="primary"
        ghost
      />
      <Context
        gaEventCategory={gaEventCategory}
        offerCoupon={offerCoupon}
        offerId={offerId}
        offerInstructions={offerInstructions}
        offerPrice={offerPrice}
        offerPriceType={offerPriceType}
        offerStatusName={offerStatusName}
        userId={userId}
      />
    </>
  );
};

Actions.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  keywords: PropTypes.arrayOf(PropTypes.string),
  offerCoupon: PropTypes.string.isRequired,
  offerId: PropTypes.number.isRequired,
  offerInstructions: PropTypes.string.isRequired,
  offerLikes: PropTypes.number.isRequired,
  offerPrice: PropTypes.number.isRequired,
  offerPriceType: PropTypes.string.isRequired,
  offerStatusName: PropTypes.string.isRequired,
  offerTitle: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
};

export default Actions;
